import React, { useEffect } from 'react'
import api from '../../api/axios';
import { useBookStore } from '../../provider/BookStore';
import Topbar from '../layout/Topbar';
import { useNavigate } from 'react-router-dom';
import Navbar from '../layout/Navbar';

const Debt = () => {
    const bookState = useBookStore();
    const book = bookState.book;

    const navigate = useNavigate();

    useEffect(() => {
        getDebts();
    }, []);

    const getDebts = async () => {
        await api.post('/debts', {
            book_id: book.id
        }).then(res => {
            console.log(res.data)
        })
    }
    return (
        <div>
            <Topbar
                title={'Hutang'}
                back={() => navigate('/')}
            />
            <div className='container p-5'>

                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Debt
